import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {getChoiceSchema, selectFlowType} from 'api';
import {handleApiError} from 'helpers';
import {Spinner, LoaderContainer, ActionButton} from '../commons';
import Choice from './Choice';
import {ProgressBar} from 'components/ProgressBar';

const propTypes = {
  updateStatus: PropTypes.func.isRequired,
  kycData: PropTypes.object,
};

const ChoiceContainer = ({updateStatus, kycData}) => {
  const [choicesData, setFormSchema] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchSchema();
  }, []);

  const fetchSchema = async () => {
    try {
      setIsLoading(true);
      const response = await getChoiceSchema();
      setFormSchema(response?.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSubmit = async (value) => {
    try {
      setIsLoading(true);
      const res = await selectFlowType({selection: value});
      if (res.status === 200) {
        updateStatus();
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <LoaderContainer>
      <ProgressBar />
    </LoaderContainer>
  ) : (
    <>
      {choicesData ? (
        <Choice apiResponse={choicesData} handleSubmit={handleSubmit} />
      ) : (
        <NoDataCard>
          <NoDataTitle>No data found</NoDataTitle>
          <NoDataText>
            We couldn't retrieve the list of options for KYC ID proof verification
          </NoDataText>
          <ActionButton
            buttonText="Try again"
            callback={() => window.location.reload()}
            className="refresh-btn"
            additionalStyles={{marginTop: '1.5rem', maxWidth: 200}}
          />
        </NoDataCard>
      )}
    </>
  );
};

ChoiceContainer.prototype = propTypes;

const NoDataCard = styled.div`
  max-width: 400px;
  margin: 3rem auto;
  padding: 2rem 1.5rem;
  background: ${({theme}) => theme.colors.accent?.floralWhite || '#FFF8EA'};
  border-radius: ${({theme}) => theme.borderRadius.lg || '1rem'};
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${({theme}) => theme.colors.feedback.warning};
`;

const NoDataTitle = styled.h2`
  color: ${({theme}) => theme.colors.feedback.warning};
  font-size: ${({theme}) => theme.typography.fontSize.lg};
  font-weight: ${({theme}) => theme.typography.fontWeight.semiBold};
  margin-bottom: 1rem;
`;

const NoDataText = styled.p`
  color: ${({theme}) => theme.colors.text.secondary};
  font-size: ${({theme}) => theme.typography.fontSize.md};
  margin-bottom: 0.5rem;
  line-height: 1.6;
`;

export default ChoiceContainer;
